import { PRICING_PAGE } from "@/lib/constants";

export default function UsagePricing() {
  const { usagePricing } = PRICING_PAGE;

  return (
    <section
      data-testid="usage-pricing-section"
      className="bg-white py-12 md:py-20"
      aria-label="Usage pricing"
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#1A1A1A] tracking-tight mb-4">
            {usagePricing.heading}
          </h2>
          <p className="text-[#6B7280] text-base leading-relaxed">
            {usagePricing.subheading}
          </p>
        </div>

        {/* Desktop table */}
        <div
          data-testid="usage-table"
          className="hidden sm:block bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm"
        >
          <table className="w-full">
            <thead>
              <tr className="bg-gray-50 border-b border-gray-200">
                <th className="text-left text-sm font-semibold text-[#1A1A1A] p-4">Item</th>
                <th className="text-left text-sm font-semibold text-[#1A1A1A] p-4">Rate (inc GST)</th>
                <th className="text-left text-sm font-semibold text-[#6B7280] p-4">Notes</th>
              </tr>
            </thead>
            <tbody>
              {usagePricing.items.map((row, i) => (
                <tr
                  key={row.item}
                  data-testid={`usage-row-${i}`}
                  className={`border-b border-gray-100 last:border-b-0 ${
                    i % 2 === 0 ? "bg-white" : "bg-[#F9FAFB]"
                  }`}
                >
                  <td className="text-sm text-[#1A1A1A] p-4 font-medium">{row.item}</td>
                  <td className="text-sm text-[#1A1A1A] p-4 font-bold">{row.rate}</td>
                  <td className="text-sm text-[#6B7280] p-4">{row.notes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile stacked cards */}
        <div className="sm:hidden space-y-3" data-testid="usage-cards-mobile">
          {usagePricing.items.map((row, i) => (
            <div
              key={row.item}
              data-testid={`usage-card-${i}`}
              className="bg-white border border-gray-200 rounded-xl p-4"
            >
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-medium text-[#1A1A1A]">{row.item}</span>
                <span className="text-sm font-bold text-[#1A1A1A]">{row.rate}</span>
              </div>
              <span className="text-xs text-[#6B7280]">{row.notes}</span>
            </div>
          ))}
        </div>

        {/* Typical spend callout */}
        <div
          data-testid="usage-callout"
          className="mt-8 bg-[#D8FFB8]/20 border border-[#20611B]/15 rounded-xl p-6 md:p-8 text-center"
        >
          <h3 className="font-heading text-lg md:text-xl font-bold text-[#1A1A1A] mb-2">
            {usagePricing.callout.heading}
          </h3>
          <p className="text-sm text-[#6B7280] leading-relaxed max-w-lg mx-auto">
            {usagePricing.callout.body}
          </p>
        </div>
      </div>
    </section>
  );
}
